/* Copyright (c) 2025 Xperi. All Rights Reserved. */

interface RecordingActivityInfoProps {
    preview: string;
}

const RecordingActivityInfo = ({ preview }: RecordingActivityInfoProps) => {
    return (
        <div className="conflict-wrapper" data-testid="preview-conflict-info">
            <div className="conflict content-airing-info program-preview-top">
                <span>{preview}</span>
                <div className="status-icon">
                    <div className="recording-info"></div>
                </div>
            </div>
        </div>
    );
};

export default RecordingActivityInfo;
